import TOP_BARS from '@/utils/topBars';
export default [
  {
    path: '/student/card/sbp',
    name: 'student-card-sbp',
    meta: {
      title: 'Student Business Pioneer'
    },
    component: () => import('../../views/sbp/Home')
  },
  {
    path: '/student/card/openning',
    name: 'student-card-openning',
    meta: {
      title: '开幕式'
    },
    component: () => import('../../views/student/Manager/Events/Openning')
  },
  {
    path: '/student/card/ending',
    name: 'student-card-ending',
    meta: {
      title: '闭幕式'
    },
    props: {
      ending: true
    },
    component: () => import('../../views/student/Manager/Events/Openning')
  },
  {
    path: '/student/card/mission-x',
    name: 'student-card-mission-x',
    meta: {
      title: 'mission-x'
    },
    props: {
      student: true
    },
    component: () => import('../../views/student/Manager/Events/MissionX')
  },
  {
    path: '/student/card/mission-x/show',
    name: 'student-card-mission-x-show',
    meta: {
      title: 'mission-x'
    },
    props: {
      student: true
    },
    component: () => import('../../views/student/Manager/Events/MissionX/Show')
  },
  {
    path: '/student/card/mission-x/show-all',
    name: 'student-card-mission-x-show-all',
    meta: {
      title: 'mission-x'
    },
    props: {
      student: true
    },
    component: () => import('../../views/student/Manager/Events/MissionX/Show/All')
  },
  {
    path: '/student/card/mission-x/show-detail',
    name: 'student-card-mission-x-show-detail',
    meta: {
      title: 'mission-x'
    },
    props: {
      student: true
    },
    component: () => import('../../views/student/Manager/Events/MissionX/Show/Detail')
  },
  {
    path: '/teacher/card/mission-x',
    name: 'teacher-card-mission-x',
    meta: {
      title: 'mission-x'
    },
    props: {
      teacher: true
    },
    component: () => import('../../views/student/Manager/Events/MissionX')
  },
  {
    path: '/student/card/talent-show',
    name: 'student-card-talent-show',
    meta: {
      title: 'Talent Show'
    },
    component: () => import('../../views/student/Manager/Events/TalentShow')
  },
  {
    path: '/student/card/mc',
    name: 'student-card-mc',
    meta: {
      title: 'Master Class'
    },
    component: () => import('../../views/student/CardEntry2022/MC')
  },
  {
    path: '/student/card/cw',
    name: 'student-card-cw',
    meta: {
      title: 'Cornerstone Workshop'
    },
    component: () => import('../../views/student/CardEntry2022/CW')
  },
  {
    path: '/student/card/ao',
    name: 'student-card-ao',
    meta: {
      title: 'Admission Officer'
    },
    component: () => import('../../views/student/CardEntry2022/AO')
  },
  {
    path: '/student/card/hsylcer',
    name: 'student-card-hsylcer',
    meta: {
      title: '电台'
    },
    component: () => import('../../views/student/Manager/Events/Hsylcer')
  },
  {
    path: '/student/card/honor',
    name: 'student-card-honor',
    meta: {
      title: '荣誉学生评选标准'
    },
    component: () => import('../../views/student/Manager/Honor')
  },
  {
    path: '/student/card/hub',
    name: 'student-card-hub',
    meta: {
      title: 'HSYLC INTEREST HUB'
    },
    component: () => import('../../views/student/Manager/Group')
  },
  {
    path: '/student/card/land',
    name: 'student-card-land',
    meta: {
      title: 'Land'
    },
    component: () => import('../../views/student/Manager/Events/Land')
  },
  {
    path: '/student/card/forum',
    name: 'student-card-forum',
    meta: {
      title: '论坛'
    },
    component: () => import('../../views/student/Manager/Events/Forum')
  },
  {
    path: '/student/card/coop',
    name: 'student-card-coop',
    meta: {
      title: 'Coop'
    },
    component: () => import('../../views/student/Manager/Events/Coop')
  },
  {
    path: '/teacher/card/forum',
    name: 'teacher-card-forum',
    meta: {
      title: '论坛'
    },
    props: {
      teacher: true
    },
    component: () => import('../../views/student/Manager/Events/Forum')
  },
  {
    path: '/student/card/haa',
    name: 'student-card-haa',
    meta: {
      title: 'HAA'
    },
    component: () => import('../../views/student/Manager/Events/HAA/Home')
  }
];
